<template>
<f7-app :params="f7params" color-theme="teal">
  <f7-panel right cover theme-dark>
    <f7-page>
      <f7-navbar title="Menu"></f7-navbar>
      <f7-list>
          <f7-list-item link="/home" title="Home" panel-close></f7-list-item>
          <f7-list-item link="/insights" title="Insights" panel-close></f7-list-item>
          <f7-list-item link="/history" title="History" panel-close></f7-list-item>
      </f7-list>
      <f7-list>
          <f7-list-item v-if="!installed" link="/install" title="Install" panel-close></f7-list-item>
      </f7-list>
      <f7-list>
          <f7-list-item link="/settings" title="Settings" panel-close></f7-list-item>
          <f7-list-item link="#" @click="contact()" title="Contact me" panel-close></f7-list-item>
          <f7-list-item link="/about" title="About" panel-close></f7-list-item>
      </f7-list>
    </f7-page>
  </f7-panel>
  <f7-navbar v-if="$store.shared" theme-dark style="height: 40px;" class="rr-ignore">
    <f7-nav-title subtitle="Sharing session"></f7-nav-title>
    <f7-nav-right>
      <f7-link @click="stopShare($event)" icon-ios="f7:xmark" icon-aurora="f7:xmark" icon-md="material:close" color="orange"></f7-link>
    </f7-nav-right>
  </f7-navbar>
  <f7-view main class="safe-areas" url="/" :push-state="true" :class="$store.shared ? 'reduced-height' : ''"></f7-view>
</f7-app>
</template>

<style>
.view.reduced-height {
  height: calc(100% - var(--f7-appbar-app-offset, 0px) - 40px);
}
</style>

<script>
  import Routes from '../js/routes.js';
  import Email from '../js/email.js';
  import Record from '../js/record.js';
  import Narration from '../js/narration.js';

  export default {
    data() {
      return {
        f7params: {
          name: 'Wuju',
          theme: 'auto',
          routes: Routes,
          swipe: 'both',
          swipeOnlyClose: true,
          dialog: {
            keyboardActions: true,
            autoFocus: true,
          }
        },
        installed: false,
      };
    },
    methods: {
      toggleFullScreen() {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          document.documentElement.requestFullscreen();
        }
      },
      contact() {
        Email.openContactDialog(this.$f7);
      },
      onRouteChange() {
        if (Narration.playing()) {
          Narration.stop().ting();
        }
      },
      stopShare(event) {
        Record.stop();
        this.$store.shared = false;
        this.$f7.views.main.router.navigate(`/home`);
      },
    },
    mounted() {
      this.$f7ready(() => {
        this.$f7.on('routeChange', this.onRouteChange);

        // don't display install prompt (handled manually in /home)
        window.addEventListener('beforeinstallprompt', (event) => {
          event.preventDefault();
        });
        this.installed = this.$f7.device.standalone;

        // set up heap properties
        heap.addUserProperties({ installed: this.installed });
        heap.clearEventProperties();
        heap.addEventProperties({ installed: this.installed });
      });
    },
  }
</script>
